import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";
import SrvButton from "../../../components/global/SrvButton";
import ErrorAdd from "../../../util/ErrorAdd";

function BoardModalArchive({ show, onHide, onHideBoard, idBoard, name }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        //Действия при открытии модального окна
        if (show === true) {

        }
        else {

        }
    }, [show]);

    function archiveHandler() {
        setLoading(true);
        setLog(null);

        axios.post('/api_tracker/board/archive', { ID_Board: idBoard })
            .then((res) => {
                if (res.data.Status === 1) {
                    onHide();
                    onHideBoard();
                    setLoading(false);
                }
                else {
                    setLoading(false);
                    setLog(res.data.Error);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center">Архивирование доски</div>

                    <div className="text-center fs-5 mt-20">Подтвердите архивирование доски <b>{name}</b></div>

                    {log !== null && <div className="form_error text-center mt-10">{log}</div>}
                    <div className="row mt-20">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="archive" size='lg' loading={loading} onClick={() => archiveHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default BoardModalArchive;
